import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import '../../styles/RequestDemo.css';
import FirstSetp from './component/FirstSetp';
import SconedStep from './component/SconedStep';
import ThirdStep from './component/ThirdStep';
import { formatPhoneNumberDivision } from '../../utlites';
import { IoArrowBackOutline } from 'react-icons/io5';

export default function RequestDemo() {
    const [currentStep, setCurrentStep] = useState(0);
    const [loading , setLoading] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertType, setAlertType] = useState('success');
    const [showAlert, setShowAlert] = useState(false);
    const [planId, setPlanId] = useState('');
    const [billingCycle, setBillingCycle] = useState('yearly');
    const totalSteps = 3;

    // Validation schemas for each step
    const validationSchemas = [
        Yup.object({
            contactName: Yup.string()
                .min(2, 'Name must be at least 2 characters')
                .required('Contact name is required'),
            email: Yup.string()
                .email('Invalid email address')
                .required('Email is required'),
            phone: Yup.string()
                .matches(/^[0-9+\-\s()]*$/, 'Invalid phone number')
                // .min(10, 'Phone number must be at least 10 digits')
                .required('Phone number is required'),
            hearAbout: Yup.string(),
            password: Yup.string()
                .required('Password is required')
                .min(8, 'Password must be at least 8 characters')
                .matches(
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&()[\]{}\-_=+;:'",.<>\/\\|`~]).+$/,
                    'Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character'
                ),
        }),
        Yup.object({
            companyName: Yup.string().required('Company name is required'),
            companySize: Yup.string(),
            industry: Yup.string(),
        }),
        Yup.object({
            selectedPlan: Yup.string(),
        })
    ];

    const initialValues = {
        contactName: '',
        email: '',
        phone: '',
        phoneCode: '+1',
        companyPhoneCode: "",
        hearAbout: '',
        companyName: '',
        companySize: '',
        companyPhone: '',
        industry: '',
        message: '',
        selectedPlan: '', // Add this
        billingCycle: 'yearly', // Add this 
    };

    const handleAlert = (message, type) => {
        setAlertMessage(message);
        setAlertType(type);
        setShowAlert(true);

        // Auto-hide success alerts after 5 seconds
        if (type === 'success') {
            setTimeout(() => {
                setShowAlert(false);
            }, 5000);
        }
    };

    const handleSubmit = async (data) => {
        console.log("loading is true and sumbit value");
        try {
            const API_URL = process.env.REACT_APP_BASE_URL;
            setLoading(true);
            console.log('Submitting to:', `${API_URL}/subscribe_company`);
            console.log('Data:', data);

            const response = await fetch(`${API_URL}/subscribe_company`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'appname': 'LimeTi',
                },
                body: JSON.stringify(data)
            });

            const result = await response.json();

            console.log('Response:', result);

            if (response.ok && result.success) {
                handleAlert(
                    'Subscription successful! You will be redirected to the login page shortly.',
                    'success'
                );

                // Optional: Redirect to success page after 2 seconds
                // Redirect to login page in a new tab after 2 seconds
                setTimeout(() => {
                    window.open(`${process.env.REACT_APP_DASBOARD_URL}/login`, '_blank', 'noopener,noreferrer');
                }, 2000);

                // Reset form
                formik.resetForm();
                setCurrentStep(0);
            } else {
                handleAlert(result.message || 'Failed to create subscription. Please try again.', 'danger');
            }
        } catch (e) {
            console.error('Submission error:', e);
            handleAlert('An error occurred. Please check your connection and try again.', 'danger');
        } finally {
            setLoading(false);
        }
    };

    const formik = useFormik({
        initialValues,
        validationSchema: validationSchemas[currentStep],
        onSubmit: async (values) => {
            console.log(currentStep < totalSteps - 1);
            if (currentStep < totalSteps - 1) {
                setCurrentStep(currentStep + 1);
            } else {
                const {countryCode:code , phone} = formatPhoneNumberDivision(values?.phoneCode, values?.phone,);
                // Handle form submission
                const objData={
                    company:{
                        company_name: values?.companyName,
                        employee_count: values?.companySize,
                        industry: values?.industry,
                        overtime_rate_multiplier: 1.5,
                        over_time: "Daily",
                        minutes_before_clock_in_shift: "60",
                        business_phone_number: formatPhoneNumberDivision(values?.companyPhoneCode, values?.companyPhone)?.phone,
                        business_phone_code: formatPhoneNumberDivision(values?.companyPhoneCode, values?.companyPhone)?.countryCode,
                    },
                    user:{
                        full_name: values?.contactName,
                        first_name: values?.contactName.split(' ')[0],
                        last_name: values?.contactName.split(' ')[1],
                        email: values?.email,
                        phone_number: phone,
                        phone_number_code: code,
                        user_type: "Company Admin",
                        password: values?.password,
                    },
                    address:{},
                    plan:{
                        id: planId || null,
                        billing_cycle: billingCycle || null
                    }
                }
                await handleSubmit(objData)
            }
        }
    });

    const handlePrev = () => {
        setCurrentStep((prev) => Math.max(prev - 1, 0));
    };


    return (
        <div 
            style={{
                display: 'flex',
                justifyContent: currentStep === 2 ? 'flex-start' :'center',
                alignItems: 'center',
                width: "100%",
                background: "#fff",
                flexDirection: "column",
            }}
        >

            {/* Show the alert */}
            {showAlert && (
                <div
                    className={`alert alert-${alertType} alert-dismissible fade show mt-2`}
                    role="alert"
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: '50%',
                        right: 0,
                        zIndex: 9999,
                        margin: '0',   
                        padding: '1rem', 
                        transform: 'translateX(-50%)',
                        width: '80%',
                        maxWidth: '600px',
                    }}
                >
                    {alertMessage}
                    <button type="button" className="btn-close" onClick={() => setShowAlert(false)}></button>
                </div>
            )}

            <div className="request-demo-card" style={{maxWidth: currentStep !== 2 ? "600px" : "100%"}}>
                <div className="demo-header" style={{width: "100%",flexDirection: "row" , gap: "16px",justifyContent: "center"}}>
                    {
                        currentStep ===2 && (
                            <div 
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    padding: "10px",
                                    borderRadius: "50%",
                                    backgroundColor: "#F2F2F2",
                                }}
                                onClick={handlePrev}
                            >
                                <IoArrowBackOutline size={25} />
                            </div>
                        )
                    }
                    <h2 className="demo-title-demo">
                        Please Enter Your Personal Information
                    </h2>
                </div>

                {/* Progress Steps */}
                <div className="progress-steps mb-3" data-progress={currentStep}>
                    {[0, 1, 2].map((step) => (
                        <div key={step} className="step-wrapper">
                            <div className={`step-circle ${currentStep >= step ? 'active' : ''} ${currentStep > step ? 'completed' : ''}`}>
                                {currentStep > step ? '✓' : ''}
                            </div>
                            {step < 2 && <div className={`step-line ${currentStep > step ? 'active' : ''}`} />}
                        </div>
                    ))}
                </div>

                {/* Form */}
                <form onSubmit={formik.handleSubmit}>

                    {/* Step 1 */}
                    {currentStep === 0 && (
                        <FirstSetp formik={formik}/>
                    )}

                    {/* Step 2 */}
                    {currentStep === 1 && (
                        <SconedStep formik={formik}/>
                    )}

                    {/* Step 3 */}
                    {currentStep === 2 && (
                        <ThirdStep
                            formik={formik}
                            setPlanId={setPlanId}
                            setBillingCycleText={setBillingCycle}
                            submitLoading={loading}
                        />
                    )}

                    {/* Navigation Buttons */}
                    {currentStep !== 2 && (
                        <div
                            style={{
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                // marginTop: '20px',
                                gap: "1rem"
                            }}
                        >
                            {currentStep > 0 && (
                                <button type="button" onClick={handlePrev} style={styles.btnPervious}>
                                    Previous
                                </button>
                            )}
                            <button disabled={loading} type="submit" style={styles.btnSubmit}>
                                {
                                    loading ?
                                        <div style={{ display: "flex", justifyContent: "center", }}>
                                            <div className="spinner-border" role="status">
                                                <span className="sr-only"></span>
                                            </div>
                                        </div>
                                        :
                                        currentStep < totalSteps - 1 ? 'Next' : 'Submit'
                                }
                            </button>
                        </div>
                    )}

                </form>
            </div>
        </div>
    );
}


const styles = {
    btnSubmit: {
        width: 'fit-content',
        display: "flex",
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        backgroundColor: "#7bb321",
        padding: "10px 20px",
        border: 'none',
        borderRadius: "20px"
    },
    btnPervious: {
        width: 'fit-content',
        display: "flex",
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        backgroundColor: "#e7eee7",
        padding: "10px 20px",
        border: 'none',
        borderRadius: "20px"
    }
}